import React from "react";
import AgentCountReport from "./AllReports/AgentCountReport";
import WorkedHoursReport from "./AllReports/WorkedHoursReport";
import WorkedHoursForAllAgentsReport from "./AllReports/WorkedHoursForAllAgentsReport";
import TotalWorkedHoursForAllAgentsReport from "./AllReports/TotalWorkedHoursForAllAgentsReport";
import AllOperationsReport from "./AllReports/AllOperationsReport";
import AllResourcesReport from "./AllReports/AllResourcesReport";
import ResourceByAgentIdReport from "./AllReports/ResourceByAgentIdReport";
import AllOrdersReport from "./AllReports/AllOrdersReport";
import OperationByIdReport from "./AllReports/OperationByIdReport";
import OrderByIdReport from "./AllReports/OrderByIdReport";
import ContentWrapper from '../Content';
import "./Reports.css";

function ReportsEmployee() {
    return (
        <div className="otch-reports-employee-screen">
            <ContentWrapper>
                <div className="otch-page-header">
                    <h1 className="otch-page-title">Аналитические отчеты</h1>
                    <p className="otch-page-subtitle">Получите детальную информацию о производительности, ресурсах и операциях в системе</p>
                </div>
                <div className="otch-reports-container">
                    <AgentCountReport />
                    <WorkedHoursReport />
                    <WorkedHoursForAllAgentsReport />
                    <TotalWorkedHoursForAllAgentsReport />
                    <AllOperationsReport />
                    <AllResourcesReport />
                    <ResourceByAgentIdReport />
                    <AllOrdersReport />
                    <OperationByIdReport />
                    <OrderByIdReport />
                </div>
            </ContentWrapper>
        </div>
    );
}

export default ReportsEmployee;